"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var RequirementsUtility_1 = require("../../../utils/RequirementsUtility");
var react_intl_1 = require("react-intl");
var formLayout_1 = require("../../consts/formLayout");
var icons_1 = require("@ant-design/icons");
exports.translationMessages = react_intl_1.defineMessages({
    formItem_required_errorMessage: {
        id: "formItem_required_errorMessage",
        defaultMessage: "This field is required",
    },
});
var UmzFormItem = function (props) {
    var children = props.children, onlyLabelOnFirstInList = props.onlyLabelOnFirstInList, index = props.index, defaultLabel = props.defaultLabel, defaultIsRequired = props.defaultIsRequired, initialValue = props.initialValue, additionalRules = props.additionalRules, verticalLabels = props.verticalLabels, fieldName = props.fieldName, receiverRequirementsKey = props.receiverRequirementsKey, style = props.style, defaultLabelTooltip = props.defaultLabelTooltip, intl = props.intl, receiverRequirements = props.receiverRequirements, rest = __rest(props, ["children", "onlyLabelOnFirstInList", "index", "defaultLabel", "defaultIsRequired", "initialValue", "additionalRules", "verticalLabels", "fieldName", "receiverRequirementsKey", "style", "defaultLabelTooltip", "intl", "receiverRequirements"]);
    var labelString = RequirementsUtility_1.getFieldLabelOverride(receiverRequirements, receiverRequirementsKey, defaultLabel);
    var labelTooltip = RequirementsUtility_1.getFieldLabelTooltipOverride(receiverRequirements, receiverRequirementsKey, defaultLabelTooltip);
    var label = labelTooltip
        ? react_1.default.createElement(antd_1.Tooltip, { title: labelTooltip, placement: "right" },
            react_1.default.createElement("span", null,
                labelString,
                "\u00A0",
                react_1.default.createElement(icons_1.QuestionCircleOutlined, null)))
        : labelString;
    var isRequired = RequirementsUtility_1.getFieldIsRequired(receiverRequirements, receiverRequirementsKey, defaultIsRequired);
    return (react_1.default.createElement(antd_1.Form.Item, __assign({}, verticalLabels ? formLayout_1.formItemVerticalLayout : formLayout_1.formItemLayout, { label: onlyLabelOnFirstInList
            ? index === 0
                ? label
                : null
            : label, name: fieldName, rules: [
            {
                required: isRequired,
                message: intl.formatMessage(exports.translationMessages.formItem_required_errorMessage),
            }
        ].concat((additionalRules || []) // if the array is undefined
        ), style: style, initialValue: initialValue }, rest), children));
};
exports.default = react_intl_1.injectIntl(UmzFormItem);
